import { createSlice } from "@reduxjs/toolkit";
export const gameSlice = createSlice({
  name: "game",
  initialState: {
    gameProvider: [],
    gameTitle: [],
    gameProviderV2: [],
    gameCasino: [],
    gameSlot: [],
    gameFishing: [],
    gameSport: [],
  },
  reducers: {
    setGameProvider: (state, action) => {
      state.gameProvider = action.payload;
    },
    setGameTitle: (state, action) => {
      state.gameTitle = action.payload;
    },
    setGameProviderV2: (state, action) => {
      state.gameProviderV2 = action.payload;
    },
    setGameCasino: (state, action) => {
      state.gameCasino = action.payload;
    },
    setGameSlot: (state, action) => {
      state.gameSlot = action.payload;
    },
    setGameFishing: (state, action) => {
      state.gameFishing = action.payload;
    },
    setGameSport: (state, action) => {
      state.gameSport = action.payload;
    },
  },
});

export const {
  setGameProvider,
  setGameTitle,
  setGameProviderV2,
  setGameCasino,
  setGameSlot,
  setGameFishing,
  setGameSport,
} = gameSlice.actions;

export const getGameProvider = (state) => state.game.gameProvider;
export const getGameProviderV2 = (state) => state.game.gameProviderV2;
export const getGameTitle = (state) => state.game.gameTitle;
export const getGameCasino = (state) => state.game.gameCasino;
export const getGameSlot = (state) => state.game.gameSlot;
export const getGameFishing = (state) => state.game.gameFishing;
export const getGameSport = (state) => state.game.gameSport;

export default gameSlice.reducer;
